/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Box, Divider, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Menu, MenuItem, Typography, Checkbox, alpha } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';
import debounce from 'lodash.debounce';
import Popup from '../../components/popups/popup';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Link } from 'react-router-dom';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import PostService from '../../services/postService';
import PostFilter from '../../components/filters/postFilter';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import { formatPrice, returnStringByLang } from '../../utils';
import UpdateMultiplePostModal from '../../components/modals/post/updateMultiplePostModal';
import ViewPostModal from '../../components/modals/post/viewPostModal';
import PdfOnePostV2 from '../../components/prints/pdfOnePostV2';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import UpdateChangeStatusModal from '../../components/modals/post/updateChangeStatusModal';

const Posts = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isEn = i18n.language === 'en';
    const tableHeadingStyle = { fontWeight: 'bold', backgroundColor: theme.palette.customGrey.tableHeading, cursor: 'pointer' };

    const [posts, setPosts] = useState([]);
    const [selectedPost, setSelectedPost] = useState({});
    const [items, setItems] = useState([]);

    const [selectedPage, setSelectedPage] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [selectedStreet, setSelectedStreet] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedPostStatus, setSelectedPostStatus] = useState(null);
    const [selectedType, setSelectedType] = useState('');
    const [selectedChangeStatus, setSelectedChangeStatus] = useState('');
    const [selectedTime, setSelectedTime] = useState({
        time: 'today',
        value: t('today')
    });
    const [selectedIsPagePaid, setSelectedIsPagePaid] = useState('');
    const [selectedIsDriverPaid, setSelectedIsDriverPaid] = useState('');
    const [selectedIsDriverSet, setSelectedIsDriverSet] = useState('');
    const [ids, setIds] = useState([]);

    const [searchTerm, setSearchTerm] = useState('');
    const [sortState, setSortState] = useState({ sortBy: '', order: '' });
    const [showFilter, setShowFilter] = useState(true);

    const [openView, setOpenView] = useState(false);
    const [openUpdate, setOpenUpdate] = useState(false);
    const [updateChangeStatus, setUpdateChangeStatus] = useState(false);
    const [updateAllType, setUpdateAllType] = useState('');

    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const tableContainerRef = useRef(null);
    const isFirstRender = useRef(true);

    const [showPopup, setShowPopup] = useState(false);
    const [popupMsg, setPopupMsg] = useState(false);
    const [popupType, setPopupType] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const onSort = (sort) => {
        let order = '';
        if (sort === sortState.sortBy || sortState.sortBy === '') {
            switch (sortState.order) {
                case '':
                    order = 'asc';
                    break;
                case 'asc':
                    order = 'desc';
                    break;
                case 'desc':
                    order = '';
                    break;
                default:
                    order = '';
                    break
            }
        }

        setSortState({ sortBy: order === '' ? '' : sort, order });
    };

    const sortIcon = () => {
        let icon = <></>;
        switch (sortState.order) {
            case 'asc':
                icon = <ArrowDownwardOutlinedIcon fontSize="small" />;
                break;
            case 'desc':
                icon = <ArrowUpwardOutlinedIcon fontSize="small" />;
                break;
            default:
                icon = <ArrowDownwardOutlinedIcon fontSize="small" sx={{ color: 'transparent' }} />;
                break
        }

        return icon;
    };

    const handleOpenView = (post) => {
        setSelectedPost(post);
        setOpenView(true);
    };
    const handleCloseView = () => setOpenView(false);

    const handleOpenUpdateChangeStatus = (post) => {
        setSelectedPost(post);
        setUpdateChangeStatus(true);
    };
    const handleCloseUpdateChangeStatus = () => setUpdateChangeStatus(false);


    const handlePrint = async (id) => {
        try {
            console.log("printing post " + id);
            const response = await PostService.sendPostToPrint(id);
            console.log(response);
        } catch (error) {
            console.error('Error sending post:', error);
        }
    };

    const handleCloseUpdate = async ({ isReaload }) => {
        setOpenUpdate(false);
        if (isReaload) {
            if (page !== 1) setPage(1);
            else await fetchPosts(1, searchTerm, selectedStreet?.id, selectedCity?.id, selectedDriver?.id,
                selectedPage?.id, selectedPostStatus?.id, selectedType, selectedBranch?.id, selectedChangeStatus);
        }
    };

    const handleType = (type) => {
        if (type === t("new")) return "new";
        else if (type === t("change")) return "change";
    };

    const handleChangeStatus = (status) => {
        if (status === t("driver")) return "driver";
        else if (status === t("inOffice")) return "inOffice";
        else if (status === t("returnToPage")) return "returnToPage";
    };

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    const fetchPosts = async (page = 1, name = '',
        streetId = null, cityId = null, driverId = null, pageId = null, postStatusId = null, type = '', branchId = null, changeStatus) => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            let filters = {
                name, streetId, cityId, driverId, branchId,
                pageId, postStatusId,
                type: handleType(type),
                changeStatus: handleChangeStatus(changeStatus),
                isPagePaid: selectedIsPagePaid,
                isDriverPaid: selectedIsDriverPaid,
                ids: JSON.stringify(ids),
                ...selectedTime,
                ...sortState,
            };

            if (selectedIsDriverSet === 'true') {
                filters.isDriverSet = 'false';
            }

            console.log(filters);
            console.log(page);


            const data = await PostService.fetch(page, filters);
            // console.log(data);


            if (data.length === 0) {
                setHasMore(false);
                if (page === 1) {
                    setPosts([]);
                }
            } else {
                setPosts(prev => {
                    const merged = page === 1 ? data : [...prev, ...data];
                    // Remove duplicates by id
                    const unique = Array.from(new Map(merged.map(item => [item.id, item])).values());
                    return unique;
                });
                setHasMore(true);
            }
        } catch (error) {
            console.error('Error fetching posts:', error);
        } finally {
            console.log("isLoading false bw");

            setIsLoading(false);
        }
    };

    const handleScroll = (event) => {
        const container = event.currentTarget;

        if (container.scrollTop === 0 && container.scrollLeft !== 0) return;

        if (container.scrollTop + container.clientHeight >= container.scrollHeight - 50) {
            if (hasMore && !isLoading) {
                fetchPosts(page + 1, searchTerm, selectedStreet?.id, selectedCity?.id, selectedDriver?.id,
                    selectedPage?.id, selectedPostStatus?.id, selectedType, selectedBranch?.id, selectedChangeStatus);
                setPage(prevPage => prevPage + 1);
            }
        }
    };

    const updateAll = async ({ type }) => {
        try {
            console.log({ type });

            setUpdateAllType(type);
            if (posts.length !== 0) {
                const checkPaid = posts.some((post) => (post.isPagePaid === true || post.isDriverPaid === true));
                const checkDeliverd = posts.some((post) => post.postStatus.type === 'done');
                // const checkNewType = posts.some((post) => post.type === 'new');
                if (type === 'postStatus' && selectedPostStatus === null) {
                    setPopupMsg(t('pleaseSelectPostStatus'));
                    setPopupType('error');
                    setShowPopup(true);
                } else if (type === 'driver' && selectedDriver === null) {
                    setPopupMsg(t('pleaseSelectDriver'));
                    setPopupType('error');
                    setShowPopup(true);
                } else if (checkPaid && type !== 'changeStatus') {
                    setPopupMsg(t('updateAllPaidError'));
                    setPopupType('error');
                    setShowPopup(true);
                } else if (checkDeliverd && type !== 'changeStatus') {
                    setPopupMsg(t('updateAllDoneError'));
                    setPopupType('error');
                    setShowPopup(true);
                } else if (type === 'changeStatus' &&
                    (selectedType === null || selectedType === '' || handleType(selectedType) === 'new')) {
                    // checkNewType && handleType(selectedType) === 'change'
                    setPopupMsg(t('pleaseSelectChangeType'));
                    setPopupType('error');
                    setShowPopup(true);
                } else {
                    setOpenUpdate(true);
                }

            }

        } catch (error) {
            console.error('Error updating posts:', error);
        }
    };

    const debouncedFetchData = useMemo(() =>
        debounce((name, streetId, cityId, driverId, pageId, postStatusId, type, branchId, changeStatus) => {
            setPage(1);
            setHasMore(true);
            fetchPosts(1, name, streetId, cityId, driverId, pageId, postStatusId, type, branchId, changeStatus);
        }, 1000),
        [selectedTime, selectedIsPagePaid, selectedIsDriverPaid, selectedIsDriverSet, ids, sortState]
    );

    const handleSearchChange = (value) => {
        setSearchTerm(value);
        debouncedFetchData(value, selectedStreet?.id, selectedCity?.id, selectedDriver?.id,
            selectedPage?.id, selectedPostStatus?.id, selectedType, selectedBranch?.id, selectedChangeStatus);
    };

    const resetFilter = () => {
        setSearchTerm('');
        setSelectedPage(null);
        setSelectedCity(null);
        setSelectedDriver(null);
        setSelectedStreet(null);
        setSelectedPostStatus(null);
        setSelectedType('');
        setSelectedChangeStatus('');
        setHasMore(true)
        setSelectedTime({
            time: 'today',
            value: t('today')
        });
        setSelectedIsPagePaid('');
        setSelectedIsDriverPaid('');
        setSelectedIsDriverSet('');
        setIds([]);
        if (page !== 1) setPage(1);
    };

    const handleCheckboxChange = (index) => {
        const updatedItems = [...items];
        updatedItems[index].selected = !updatedItems[index].selected;
        setItems(updatedItems);
        sessionStorage.setItem('items', JSON.stringify(updatedItems));
    };

    const isItemSelected = (nameToCheck) => {
        return items.some(item => item.name === nameToCheck && item.selected);
    };

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, key) => (acc ? acc[key] : null), obj);
    };


    useEffect(() => {
        if (isFirstRender.current) {
            const storedItems = sessionStorage.getItem('items');
            if (storedItems) {
                setItems(JSON.parse(storedItems));
            } else {
                const initialItems = [
                    { name: 'number', value: 'number', selected: true },
                    { name: 'id', value: 'id', selected: true },
                    { name: 'receiverName', value: 'receiverName', selected: false },
                    { name: 'receiverAddress', value: 'receiverAddress', selected: false },
                    { name: 'receiverPhone', value: 'receiverPhone', selected: false },
                    { name: 'receiverPhoneTwo', value: 'receiverPhoneTwo', selected: false },
                    { name: 'invoiceNumber', value: 'invoiceNumber', selected: true },
                    { name: 'initialTotalPrice', value: 'initialTotalPrice', selected: false },
                    { name: 'totalPrice', value: 'totalPrice', selected: true },
                    { name: 'transportationPrice', value: 'transportationPrice', selected: false },
                    { name: 'driverPrice', value: 'driverPrice', selected: false },
                    { name: 'createdAt', value: 'createdAt', selected: true },
                    { name: 'postType', value: 'postType.name', selected: false },
                    { name: 'branch', value: 'branch.name', selected: true },
                    { name: 'page', value: 'page.name', selected: true },
                    { name: 'driver', value: 'driver.name', selected: true },
                    { name: 'street', value: 'street.name', selected: true },
                    { name: 'city', value: 'street.city.name', selected: false },
                    { name: 'postStatus', value: 'postStatus.englishName', selected: true },
                    { name: 'type', value: 'type', selected: false },
                    { name: 'changeStatus', value: 'changeStatus', selected: false },
                    { name: 'isPagePaid', value: 'isPagePaid', selected: false },
                    { name: 'isDriverPaid', value: 'isDriverPaid', selected: false },
                    { name: 'note', value: 'note', selected: false },
                ];
                setItems(initialItems);
                sessionStorage.setItem('items', JSON.stringify(initialItems));
            }
            isFirstRender.current = false;
            return;
        }

        if (page === 1) fetchPosts(page, searchTerm, selectedStreet?.id, selectedCity?.id, selectedDriver?.id,
            selectedPage?.id, selectedPostStatus?.id, selectedType, selectedBranch?.id, selectedChangeStatus);

    }, [page]);

    useEffect(() => {
        if (page !== 1) {
            isFirstRender.current = true;
            setPage(1);
        }
        fetchPosts(1, searchTerm, selectedStreet?.id, selectedCity?.id, selectedDriver?.id,
            selectedPage?.id, selectedPostStatus?.id, selectedType, selectedBranch?.id, selectedChangeStatus);
    }, [selectedStreet, selectedCity, selectedDriver, selectedPage, selectedPostStatus,
        selectedType, selectedChangeStatus, sortState, selectedTime, selectedIsPagePaid, selectedIsDriverPaid, selectedIsDriverSet, ids, selectedBranch?.id]);

    const postItemValue = (post, item, index) => {
        let returnString = '';
        switch (item.name) {
            case 'number':
                returnString = index + 1;
                break;
            case 'postStatus':
                returnString = returnStringByLang(post.postStatus, i18n.language);
                break;
            case 'type':
                returnString = t(post.type);
                break;
            case 'changeStatus':
                returnString = t(post.changeStatus);
                break;
            case 'isPagePaid':
                returnString = post.isPagePaid ? t("yes") : t("no");
                break;
            case 'isDriverPaid':
                returnString = post.isDriverPaid ? t("yes") : t("no");
                break;
            case 'initialTotalPrice':
                returnString = formatPrice(post.initialTotalPrice);
                break;
            case 'totalPrice':
                returnString = formatPrice(post.totalPrice);
                break;
            case 'transportationPrice':
                returnString = formatPrice(post.transportationPrice);
                break;
            case 'driverPrice':
                returnString = formatPrice(post.driverPrice);
                break;
            default:
                returnString = getNestedValue(post, item.value);
                break
        }
        return returnString;
    }

    const postItemStyle = (post, item) => {
        let returnStyle = {};
        switch (item.name) {
            case 'postStatus':
                returnStyle = {
                    fontWeight: 'bold',
                    color: post.postStatus.color
                };
                break;
            case 'changeStatus':
                if (post.changeStatus === 'driver') {
                    returnStyle = {
                        fontWeight: 'bold',
                        color: theme.palette.purple.box
                    };
                } else if (post.changeStatus === 'inOffice') {
                    returnStyle = {
                        fontWeight: 'bold',
                        color: theme.palette.blue.bg
                    };
                } else if (post.changeStatus === 'returnToPage') {
                    returnStyle = {
                        fontWeight: 'bold',
                        color: theme.palette.yellow.border
                    };
                }
                break;
            case 'isPagePaid':
                returnStyle = {
                    fontWeight: 'bold',
                    color: post.isPagePaid ? theme.palette.green.box : theme.palette.red.box
                };
                break;
            case 'isDriverPaid':
                returnStyle = {
                    fontWeight: 'bold',
                    color: post.isDriverPaid ? theme.palette.green.box : theme.palette.red.box
                };
                break;
            default:
                returnStyle = {};
                break
        }
        return returnStyle;
    }

    return (
        <Box sx={{
            p: 2,
            backgroundColor: theme.palette.secondary.main,
            width: '100%',
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <ViewPostModal open={openView} handleClose={handleCloseView} postId={selectedPost.id} />
                <UpdateChangeStatusModal
                    open={updateChangeStatus}
                    handleClose={handleCloseUpdateChangeStatus}
                    post={selectedPost}
                    setPopupMsg={setPopupMsg}
                    setPopupType={setPopupType}
                    setShowPopup={setShowPopup}
                />
                <UpdateMultiplePostModal
                    open={openUpdate}
                    handleClose={handleCloseUpdate}
                    setPopupMsg={setPopupMsg}
                    setPopupType={setPopupType}
                    setShowPopup={setShowPopup}
                    posts={posts}
                    type={handleType(selectedType)}
                    updateType={updateAllType}
                />
                {/* <ShowPrinterListModal open={openPrinter} handleClose={handleClosePrinter} postId={selectedPost.id} /> */}
            </Box>
            {showPopup && (
                <Popup
                    text={popupMsg}
                    type={popupType}
                    onClose={() => setShowPopup(false)}
                    duration={4000}
                />
            )}

            {/* Filter row */}
            <PostFilter
                handleSearchChange={handleSearchChange}
                searchTerm={searchTerm}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                selectedChangeStatus={selectedChangeStatus}
                setSelectedChangeStatus={setSelectedChangeStatus}
                selectedPostStatus={selectedPostStatus}
                setSelectedPostStatus={setSelectedPostStatus}
                resetFilter={resetFilter}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
                selectedStreet={selectedStreet}
                setSelectedStreet={setSelectedStreet}
                selectedPage={selectedPage}
                setSelectedPage={setSelectedPage}
                selectedDriver={selectedDriver}
                setSelectedDriver={setSelectedDriver}
                showFilter={showFilter}
                setShowFilter={setShowFilter}
                selectedTime={selectedTime}
                setSelectedTime={setSelectedTime}
                selectedIsPagePaid={selectedIsPagePaid}
                setSelectedIsPagePaid={setSelectedIsPagePaid}
                selectedIsDriverPaid={selectedIsDriverPaid}
                setSelectedIsDriverPaid={setSelectedIsDriverPaid}
                selectedIsDriverSet={selectedIsDriverSet}
                setSelectedIsDriverSet={setSelectedIsDriverSet}
                selectedBranch={selectedBranch}
                setSelectedBranch={setSelectedBranch}
                ids={ids}
                setIds={setIds}
                updateAll={updateAll}
                sortState={sortState}
            />

            {/* Scrollable Table with Sticky Header */}
            <TableContainer
                component={Paper}
                ref={tableContainerRef}
                sx={{
                    boxShadow: 'none',
                    border: 1,
                    borderColor: theme.palette.customGrey.borderInput,
                    borderRadius: 2,
                    height: `calc(100vh - ${showFilter ? '320px' : '160px'})`,
                    overflowY: 'auto',
                }}
                onScroll={handleScroll}
            >
                <Table stickyHeader aria-label="simple table">
                    <TableHead
                        sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 1,
                        }}
                    >
                        <TableRow>
                            {
                                items.map((item) => (
                                    isItemSelected(item.name) &&
                                    <TableCell key={item.name}
                                        align={isEn ? 'left' : 'right'}
                                        onClick={() => onSort(item.name)} sx={tableHeadingStyle}>
                                        <Box sx={{ display: 'flex' }} >
                                            {t(item.name)}
                                            {sortState.sortBy === item.name && sortIcon()}
                                        </Box>
                                    </TableCell>
                                ))
                            }

                            <TableCell align={isEn ? 'left' : 'right'} sx={{ ...tableHeadingStyle, cursor: 'auto' }}>
                                {t('actions')}</TableCell>

                            <TableCell align={isEn ? 'right' : 'left'} sx={tableHeadingStyle}>
                                <MoreVertOutlinedIcon onClick={handleOpen} />
                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                    sx={{
                                        height: '500px'
                                    }}
                                >
                                    {items.map((item, index) => (
                                        <MenuItem
                                            key={item.name}
                                            sx={{ display: 'flex', alignItems: 'center', height: 40 }}
                                        >
                                            <Checkbox
                                                checked={item.selected}
                                                onChange={() => handleCheckboxChange(index)}
                                            />
                                            <Typography variant="body1">{t(item.name)}</Typography>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {posts.map((post, index) => (
                            <TableRow
                                key={post.id} sx={{
                                    '&:last-child td, &:last-child th': { border: 0 },
                                    backgroundColor: post.isPriceUpdated
                                        ? alpha(theme.palette.red.box, 0.3)
                                        : 'inherit',
                                }}>
                                {
                                    items.map((item) => (
                                        isItemSelected(item.name) &&
                                        <TableCell key={item.name} align={isEn ? 'left' : 'right'} sx={postItemStyle(post, item)}>
                                            {postItemValue(post, item, index)}
                                        </TableCell>
                                    ))
                                }

                                {/* actions */}
                                <TableCell align={isEn ? 'left' : 'right'}>
                                    <Box sx={{
                                        display: 'inline-flex',
                                        border: 1,
                                        borderColor: theme.palette.customGrey.borderInput,
                                        backgroundColor: theme.palette.secondary.main,
                                        borderRadius: 1,
                                    }}>
                                        <Box sx={{
                                            px: 1,
                                            pt: 0.6,
                                            pb: 0.25,
                                            cursor: 'pointer'
                                        }} onClick={() => handleOpenView(post)}>
                                            <RemoveRedEyeOutlinedIcon fontSize='small'
                                                sx={{ color: theme.palette.text.primary }} />
                                        </Box>
                                        <Divider orientation="vertical" flexItem />
                                        <Box sx={{
                                            px: 1,
                                            pt: 0.4,
                                            pb: 0.25,
                                            cursor: (post.isDriverPaid || post.isPagePaid) ? 'not-allowed' : 'pointer',
                                            pointerEvents: (post.isDriverPaid || post.isPagePaid) ? 'none' : 'auto',
                                            opacity: (post.isDriverPaid || post.isPagePaid) ? 0.5 : 1,
                                        }}
                                            component={Link}
                                            to={`/posts/${post.id}`}
                                        >
                                            <DriveFileRenameOutlineOutlinedIcon fontSize='small'
                                                sx={{ color: theme.palette.text.primary }} />
                                        </Box>
                                        <Divider orientation="vertical" flexItem />
                                        <Box sx={{
                                            px: 1,
                                            pt: 0.6,
                                            pb: 0.25,
                                            cursor: post.type !== 'change' ? 'not-allowed' : 'pointer',
                                            pointerEvents: post.type !== 'change' ? 'none' : 'auto',
                                            opacity: post.type !== 'change' ? 0.5 : 1,
                                        }}
                                            onClick={() => handleOpenUpdateChangeStatus(post)}
                                        >
                                            <ChangeCircleOutlinedIcon fontSize='small'
                                                sx={{ color: theme.palette.text.primary }} />
                                        </Box>

                                        <Divider orientation="vertical" flexItem />

                                        <Box sx={{
                                            px: 1,
                                            pt: 0.6,
                                            pb: 0.25,
                                            cursor: 'pointer'
                                        }} onClick={() => handlePrint(post.id)}>
                                            <LocalPrintshopOutlinedIcon fontSize='small'
                                                sx={{ color: theme.palette.text.primary }} />
                                        </Box>
                                        <Divider orientation="vertical" flexItem />

                                        <Box sx={{
                                            px: 1,
                                            pt: 0.6,
                                            pb: 0.25,
                                            cursor: 'pointer',
                                            pointerEvents: 'auto',
                                            opacity: 1,
                                        }}>
                                            <PdfOnePostV2
                                                id={post.id}
                                            />
                                        </Box>

                                    </Box>
                                </TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        ))}

                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default Posts;
